import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getImsiWorkflowLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const IMSIWorkflowHistory = (props) => {
  const [imsiWorkflowHistory, setIMSIWorkflowHistory] = useState([]);
  const { imsi_workflow_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getImsiWorkflowLog(imsi_workflow_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setIMSIWorkflowHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          PWG IMSI Workflow Log
        </Typography>
      </Box>

      {response && imsiWorkflowHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ESN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Plan</TableCell>
                    <TableCell align="left">Zipcode</TableCell>
                    <TableCell align="left">Step</TableCell>
                    <TableCell align="left">MDN</TableCell>
                    <TableCell align="left">IMSI</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/pwg/imsi_workflow/batch/${imsiWorkflowHistory.data.batch_id}`}
                      >
                        {imsiWorkflowHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={imsiWorkflowHistory.data.status}
                        size="small"
                        color={getChipColor(imsiWorkflowHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.plan}
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.zipcode}
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.step}
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.imsi}
                    </TableCell>
                    <TableCell align="left">
                      {imsiWorkflowHistory.data.last_updated &&
                        `${format(
                          new Date(imsiWorkflowHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={imsiWorkflowHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default IMSIWorkflowHistory;
